import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject, input } from '@angular/core';
import { DealerFeature, EventTrackingService, RouterLinkDirective, TrackingDirective } from '@hyundai/ng-common-lib';
import { M010C020IconLinkComponent } from '@hyundai/ui';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-dealer-info',
    standalone: true,
    imports: [RouterLinkDirective, M010C020IconLinkComponent, TrackingDirective],
    templateUrl: './dealer-info.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DealerInfoPersonComponent {
    tracking = inject(EventTrackingService);
    store = inject(Store);

    dealer = this.store.selectSignal(DealerFeature.state.selectSubDealerOrDealer);
    showAboutUsLink = input.required<boolean>();

    aboutUsClicked() {
        this.tracking.trackButton({
            elType: 'basic link',
            event: 'element_click',
            elLabel: 'About Us',
            elTarget: this.dealer().pages.aboutUs,
        });
    }
}
